<template>
    <div>
    	<van-nav-bar
		  	title="详细信息"
			left-arrow
		  	@click-left="$router.push('/StaffBookForm')">
		</van-nav-bar>
		<van-cell title='电话' value='XXX'></van-cell>
		<van-cell title='姓名' value='XXX'></van-cell>
		<van-cell title='时间' value='XXX'></van-cell>
		<van-cell title='日期' value='XXX'></van-cell>
    </div>
</template>
<script>
  	export default {
    	data(){
    		return{

    		}
    	}
  	}
</script>
<style scoped>
    /deep/ .van-nav-bar .van-icon{
      font-size: 24px;
      color: #000;
    }
</style>


// WEBPACK FOOTER //
// src/Service/Detail.vue